































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ProcessNumberCardTemplate from '@/components/organizationDashboard/processNumber/ProcessNumberCardTemplate.vue';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import { OrganizationsRepository } from '@/repository/repositories/theoryApi/organizations.repository';
import dayjs from 'dayjs';
import { AggregationResults } from '@/@types/Organization';

@Component({
  components: {
    ProcessNumberCardTemplate
  },
})
export default class ProcessNumberBase extends Vue {
  private totalScheduleMoneyNumber: number = 0; // 消化予定予算（合計）
  private totalScheduleTimeNumber: number = 0; // 消化予定工数（合計）
  private totalCostMoneyNumber: number = 0; // 消化済み予算（合計）
  private totalCostTimeNumber: number = 0; // 消化済み予算（合計）
  private thisMonthCostMoneyNumber: number = 0; // 今月の消化済み予算
  private thisMonthCostTimeNumber: number = 0; // 今月の消化済み工数
  private lastMonthCostMoneyNumber: number = 0; // 先月の消化済み予算
  private lastMonthCostTimeNumber: number = 0; // 先月の消化済み工数
  private organizationsRepository: OrganizationsRepository = RepositoryFactory.theoryApi.organizationsRepository();
  private thisMonth: string = dayjs().format('YYYYMM');
  private lastMonth: string = dayjs().subtract(1, 'month').format('YYYYMM');

  @Prop({ required: true })
  private organizationAggregationResults!: AggregationResults[];

  @Watch('organizationAggregationResults')
  private updateOrganizationAggregationResults(newValue: AggregationResults[]) {
    if (newValue.length) {
      this.totalScheduleMoneyNumber = newValue[0].totalScheduledBudget;
      this.totalScheduleTimeNumber = newValue[0].totalScheduledManHour;
      this.totalCostMoneyNumber = newValue[0].totalUsedBudget;
      this.totalCostTimeNumber = newValue[0].totalUsedManHour;

      const lastMonthData = newValue.find(v => v.aggregationMonth === this.lastMonth);
      this.lastMonthCostMoneyNumber = lastMonthData?.usedBudget ?? 0;
      this.lastMonthCostTimeNumber = lastMonthData?.usedManHour ?? 0;
      const thisMonthData = newValue.find(v => v.aggregationMonth === this.thisMonth);
      this.thisMonthCostMoneyNumber = thisMonthData?.usedBudget ?? 0;
      this.thisMonthCostTimeNumber = thisMonthData?.usedManHour ?? 0;
    }
  }
}
